document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll('.wp-block-video').forEach(wrapper => {
        const video = wrapper.querySelector('video');

        wrapper.addEventListener('click', (e) => {
            video.paused ? video.play() : video.pause();
        });

        video.addEventListener('play', () => {
            wrapper.classList.add('is-playing');
            wrapper.classList.remove('is-paused');
        });

        video.addEventListener('pause', () => {
            wrapper.classList.add('is-paused');
            wrapper.classList.remove('is-playing');
        });
    });
});

